import BaseService from './BaseService';
import { ICardsService } from 'types/cards';

class CardsService extends BaseService implements ICardsService {
  /**
   * fetch Opportunity Cards
   * @return {Promise}
   */
  fetchOpportunityCards = () => {
    const config = {
      url: '/opportunity',
    };
    return this.doRequest(config);
  };


  /**
   * Discard Opportunity Card
   * @param  {Number} eventId
   * @return {Promise}
   */
  discardOpportunityCard = (eventId: number | null = null) => {
    const config = {
      method: 'post',
      url: '/opportunity/discard',
      data: { eventId }
    };

    return this.doRequest(config);
  };


  /**
   * Draw opportunity cards
   * @return {Promise}
   */
  drawOpportunityCards = () => {
    const config = {
      method: 'post',
      url: '/opportunity/draw',
    };
    return this.doRequest(config);
  }
}

export { CardsService as default };
